import { render, staticRenderFns } from "./ArticuloDetalle.vue?vue&type=template&id=4baf4006&"
import script from "./ArticuloDetalle.vue?vue&type=script&lang=js&"
export * from "./ArticuloDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports